import { useTheme } from '@material-ui/core';
import orange from '../../assets/ut/ut-wordmark-burnt-orange.png';
import white from '../../assets/ut/ut-wordmark-white.png';

/**
 * The University of Texas at Austin primary wordmark, unmodified, in the color
 * that suits the current theme. See assets/ut/README.md for the usage rules.
 *
 * The artwork is 226px of shield in a 715px-tall image, and the manual asks for
 * a shield of at least 50px, so it is shown 168px tall (53px shield). On a
 * narrow screen it scales down with the width, to about 50px at 330px wide.
 */
export const UtWordmark = () => {
  const theme = useTheme();
  const src = theme.palette.type === 'dark' ? white : orange;
  return (
    <img
      src={src}
      alt="The University of Texas at Austin"
      style={{ width: 'min(100%, 345px)', height: 'auto', margin: '16px 0' }}
    />
  );
};
